import React, { useState, useEffect } from "react";
import { siteData } from "../../data/mock";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Program", href: "#system" },
    { label: "Results", href: "#outcomes" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Investment", href: "#investment" },
  ];

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/95 backdrop-blur-xl border-b border-[#7dfabf]/10 shadow-lg shadow-black/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-3 group"
          >
            <img
              src={siteData.brand.logoIcon}
              alt="Booze to Beast Logo"
              className="w-10 h-10 rounded-lg transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-xl font-bold text-white tracking-tight font-heading">
              {siteData.brand.name}
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="text-sm text-white/60 hover:text-[#7dfabf] transition-colors duration-300 font-medium tracking-wide font-body"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#apply")}
              className="px-6 py-2.5 bg-[#7dfabf] text-black text-sm font-bold rounded-lg hover:bg-[#6ae0a8] transition-all duration-300 hover:shadow-lg hover:shadow-[#7dfabf]/20 font-body"
            >
              Apply Now
            </button>
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out ${
          mobileOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-black/98 backdrop-blur-xl border-t border-white/5 px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className="block w-full text-left text-white/60 hover:text-[#7dfabf] transition-colors duration-300 font-medium py-2 font-body"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#apply")}
            className="w-full mt-2 px-6 py-3 bg-[#7dfabf] text-black font-bold rounded-lg hover:bg-[#6ae0a8] transition-all duration-300 font-body"
          >
            Apply Now
          </button>
        </div>
      </div>
    </header>
  );
};
